<template>
    <AppHead :data="data.app_head_data" />
    <OrphanList :orphan-list="data.bidder_orphan_list" />
</template>

<script setup lang="ts">
import AppHead from "@main/Components/AppHead/AppHead.vue";
import { useOverviewStore } from "@stores/overview/overviewStore";
import { onMounted } from "vue";
import OrphanList from "./Components/OrphanList.vue";

defineProps<{
    data: App.Data.Main.Overview.ViewModels.OverviewIndex;
}>();

const overviewStore = useOverviewStore();

onMounted(() => {
    // Set the overview page as mounted - this is used to determine if the Overview.vue should be rendered (set in LayoutBase.vue for persistence)
    overviewStore.setHasOverviewPageMounted();
});
</script>
